import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import AgGridTable from "../../utilities/AgGridTable";
import Cards from "./Card";
import data from "./data";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { Box, Button, Card, IconButton, Tooltip, Typography } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import FormPageHeader from "../../utilities/FormPageHeader";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { useTheme } from "@mui/material";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .new, & .assigned, & .placed, & .ab_received, & .invoiced, & .inprogress": {
      borderRadius: "20px",
      fontSize: "11px",
      textAlign: "center",
      height: '26px',
      lineHeight: '26px',
      padding: '0px 10px',
      marginTop: '6px',
      color: theme.palette.common.white,
    },
    "& .new": {
      backgroundColor: theme.palette.info.main,
    },
    "& .assigned": {
      backgroundColor: theme.palette.warning.main,
    },
    "& .placed": {
      backgroundColor: theme.palette.grey[500],
    },
    "& .ab_received": {
      backgroundColor: theme.palette.success.main,
    },
    "& .invoiced": {
      backgroundColor: theme.palette.success.main,
    },
    "& .inprogress": {
      backgroundColor: theme.palette.success.main,
    },
  },
}));

const CreateNewType = (props) => {
  return (
    <>
      <Tooltip title={"Create a New Type"}>
        <IconButton>
          <FuseSvgIcon size={16} color="action">
            heroicons-solid:color-swatch
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
      {/* <Button size="small" variant="contained" color="primary" sx={{ background: '#826210', color: '#fff', fontSize: '11px'}}>Create a New Type</Button> */}
    </>
  );
};

const handleDateFormat = (props) => {
  return props.value && moment(props.value).format('DD-MM-YYYY')
}

var filterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    var dateAsString = cellValue;
    //Convert function date format from "2024-02-23T17:16:43.974" to 23/02/2024
    const date = new Date(dateAsString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    if (formattedDate == null) return -1;
    var dateParts = formattedDate.split("/");
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0]),
    );
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
  maxValidYear: new Date().getFullYear(),
};
const BookingReqList = (props) => {
  const classes = useStyles(props);
  const navigate = useNavigate();
  const theme = useTheme();
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [error, setError] = useState();
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.dashboardOrderCriteria}`;
  const [gridApi, setGridApi] = useState(null);
  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      floatingFilter: true,
      resizable: true,
      editable: true,
    };
  }, []);
  const gridStyle = useMemo(
    () => ({ height: "calc(100% - 22.2px)", width: "100%" }),
    []
  );
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  const onFilterChanged = () => {
    if (!gridApi) return;
    gridApi.refreshCells({ columns: ["srNo"] });
  };
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Sr No.",
      minWidth: 60,
      maxWidth: 60,
      field: "srNo",
      filter: false,
      resizable: true,
      valueGetter: (params) => params.node.rowIndex + 1,
    },

    { field: "abNumber", headerName: "Order .No", enableRowGroup: true, filter: "agTextColumnFilter" },
    { field: "commissionName", headerName: "Commission Name", enableRowGroup: true, filter: "agTextColumnFilter" },
    { field: "vendorName", headerName: "Product", enableRowGroup: true, filter: "agTextColumnFilter" },
    { field: "customerName", headerName: "Customer", enableRowGroup: true, filter: "agTextColumnFilter" },
    { field: "country", headerName: "Country", enableRowGroup: true, filter: "agTextColumnFilter" },
    { field: "orderCategory", headerName: "Category", enableRowGroup: true, filter: "agTextColumnFilter" },
    { field: "assignedTo", enableRowGroup: true, headerName: "Assigned To", filter: "agTextColumnFilter" },
    {
      field: "createdDate", enableRowGroup: true, headerName: "Created On", cellRenderer: handleDateFormat, filter: "agDateColumnFilter",
      filterParams
    },
    {
      field: "orderPlacedDate", enableRowGroup: true, headerName: "Processed On", cellRenderer: handleDateFormat, filter: "agDateColumnFilter",
      filterParams,
      cellClass: (params) => {
        if (params.value === "NEW") {
          return "new";
        } else if (params.value === "ASSIGNED") {
          return "assigned";
        } else if (params.value === "PLACED") {
          return "placed";
        } else if (params.value === "AB_RECEIVED") {
          return "ab_received";
        } else if (params.value === "INVOICED") {
          return "invoiced";
        } else if (params.value === "IN_PROGRESS") {
          return "inprogress";
        }
        return null;
      },
    },
  ]);


  useEffect(() => {
    if(gridApi){

      getBookingReq()
    }
  }, [gridApi])

  const getBookingReq = async () => {
    gridApi.showLoadingOverlay();
    try {
      const result = await OAuthService.getPostList(`${url}?tilesStatus=bookingReq&sort=createdDate,desc`, {});
      setRowData(result.data);
    } catch (e) {
      console.log("error", e);
      setError(e.message);
      setRowData([]);
    }finally {
    gridApi?.hideOverlay();
  }
  }

  const onRowDoubleClicked = (params) => {
    var filename = params?.data?.id;
    navigate("/order/order-details/" + filename);
  };

  const handleCreateOrder = () => {
    navigate("/create-order/");
  }

  const onBtExport = useCallback(() => {
    const params = {
      fileName: 'BookingRequests.xlsx',
      sheetName: 'Booking Requests'
    }
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const handleBack = () => {
    navigate("/order/dashboard");
  };

  const orderHeaderAction = () => {
    // const navigate = useNavigate();
    return (
      <>
        <Tooltip title={"Back"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleBack}
            size="small"
            sx={{ minWidth: 'auto' }}
          >
            <FuseSvgIcon size={18}>heroicons-solid:arrow-narrow-left</FuseSvgIcon>
          </Button>
        </Tooltip>
        <Tooltip title={"Export Booking Request List"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onBtExport}
            size="small"
            sx={{ minWidth: 'auto' }}
          >
            <FuseSvgIcon size={18}>heroicons-solid:save</FuseSvgIcon>
          </Button>
        </Tooltip>
      </>
    );
  };

  return (
    <>
      <FormPageHeader error={error} componentName="Booking Requests" pageName="Booking Requests" currentPage={'Booking Requests'} orderHeaderAction={orderHeaderAction()}>
        {/* <Box className="flex px-16" sx={{ pb: 1 }}>
                <Box sx={{ px: 1 }}>
                  <Select
                    required
                    placeholder={'Customer'}
                    // options={sortOptions}
                    styles={customStyles()}
                    className="w-full"
                  />
                </Box>
                <Box sx={{ px: 1 }}>
                  <Select
                    required
                    placeholder={'Country'}
                    // options={sortOptions}
                    styles={customStyles()}
                    className="w-full"
                  />
                </Box>
                <Box sx={{ px: 1 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ height: 30, minHeight: 30, maxHeight: 30, fontSize: 11 }}
                  >
                    Search
                  </Button>
                </Box>
              </Box> */}
      </FormPageHeader>
      <div className={clsx(classes.root, "h-full order-grid")} style={{ height: "100%", width: "100%" }}>
        <div
          style={gridStyle}
          className={`grid ${theme.palette.mode === "dark"
              ? "ag-theme-alpine-dark"
              : "ag-theme-alpine"
            }`}
        >
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            defaultColDef={defaultColDef}
            onFilterChanged={onFilterChanged}
            ref={gridRef}
            onRowDoubleClicked={onRowDoubleClicked}
            cellSelection={true}
            suppressRowClickSelection={true}
            hideCheckbox={true}
            editable={false}
            rowHeight={22}
            headerHeight={30}
          />
        </div>
      </div>
    </>
  );
};

export default BookingReqList;
